module.exports = __webpack_public_path__ + "img/separator3.410feb9e.svg";